import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import authSlice from './auth';

export type NotificationsState = {
    unreadCount: number
}

const initialState: NotificationsState = {
    unreadCount: 0,
};

/**
 * Shared unread-notification count so the header bell, side nav and menu all show
 * the same badge without each fetching it. NotificationList is the only writer.
 */
const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setUnreadCount(state: NotificationsState, action: PayloadAction<number>) {
            state.unreadCount = Math.max(0, action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(authSlice.actions.setLogout, () => initialState);
    },
});

export default notificationsSlice;
